import React from "react";
import {
  Switch,
  FormControlLabel,
  FormHelperText,
  FormControl,
} from "@mui/material";

const CustomSwitch = (props) => {
  const {
    label = "",
    checked = false,
    onChange,
    name,
    error = false,
    helperText = "",
    isReadOnly = false,
    isLock = false,
    disabled = false,
    sx = {}
  } = props;

  return (
    <FormControl error={!!error} >
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(_, newValue) => {
              if (!isReadOnly && !isLock && onChange) {
                onChange(newValue);
              }
            }}
            name={name}
            disabled={isLock || disabled}
          />
        }
        label={label}
        sx={[sx]}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSwitch;
